// src/index.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function Button({
  variant = "primary",
  className = "",
  ...props
}) {
  return /* @__PURE__ */ jsx("button", { className: `button button--${variant} ${className}`.trim(), ...props });
}
function Card({ className = "", ...props }) {
  return /* @__PURE__ */ jsx("section", { className: `card ${className}`.trim(), ...props });
}
function Field({
  label,
  hint,
  error,
  children
}) {
  return /* @__PURE__ */ jsxs("label", { className: "field", children: [
    /* @__PURE__ */ jsx("span", { className: "field__label", children: label }),
    children,
    error ? /* @__PURE__ */ jsx("span", { className: "field__error", children: error }) : hint ? /* @__PURE__ */ jsx("span", { className: "field__hint", children: hint }) : null
  ] });
}
function Input(props) {
  return /* @__PURE__ */ jsx("input", { className: "input", ...props });
}
function Metric({ label, value, unit, footnote }) {
  return /* @__PURE__ */ jsxs("div", { className: "metric", children: [
    /* @__PURE__ */ jsx("span", { className: "eyebrow", children: label }),
    /* @__PURE__ */ jsxs("div", { className: "metric__value", children: [
      value,
      " ",
      unit ? /* @__PURE__ */ jsx("small", { children: unit }) : null
    ] }),
    footnote ? /* @__PURE__ */ jsx("span", { className: "metric__footnote", children: footnote }) : null
  ] });
}
function ProgressBar({ value, max, label }) {
  const percentage = Math.min(100, Math.max(0, max ? value / max * 100 : 0));
  return /* @__PURE__ */ jsx("div", { className: "progress", "aria-label": `${label}: ${Math.round(percentage)}%`, role: "progressbar", "aria-valuemin": 0, "aria-valuemax": max, "aria-valuenow": value, children: /* @__PURE__ */ jsx("span", { style: { width: `${percentage}%` } }) });
}
function EmptyState({ icon, title, children, action }) {
  return /* @__PURE__ */ jsxs("div", { className: "empty-state", children: [
    icon ? /* @__PURE__ */ jsx("div", { className: "empty-state__icon", children: icon }) : null,
    /* @__PURE__ */ jsx("h2", { children: title }),
    /* @__PURE__ */ jsx("div", { children }),
    action
  ] });
}
function Skeleton({ className = "" }) {
  return /* @__PURE__ */ jsx("span", { className: `skeleton ${className}`.trim(), "aria-hidden": "true" });
}
export {
  Button,
  Card,
  EmptyState,
  Field,
  Input,
  Metric,
  ProgressBar,
  Skeleton
};
